import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import { EditAccountOpeningBal, GetAccountByID } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const EditAccount = () => {
  const navigate = useNavigate();
  let param = useParams();
  const acc_id = param.Account_id;
  const { storeG } = useStateContext();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: "Select Type",
    balance: "0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Account");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }

    const type_id = formData.type.value;
    try {
      const response = await EditAccountOpeningBal(
        acc_id,
        storeG.store_id,
        formData.name,
        formData.description,
        formData.balance,
        type_id,
        formData.notes,
      );
      if (response.success) {
        showSuccessToast("Success!", "Account updated successfully!");
        navigate("/Account");
      } else
        showErrorToast(
          "Error!",
          "Account failed to updated!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Account failed to updated!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (acc_id) {
        await GetAccountByID(acc_id)
          .then((resp) => {
            setFormData({
              name: resp.data.name || "",
              description: resp.data.description || "",
              type: resp.data.type
                ? { label: resp.data.type, value: resp.data.type_id }
                : "Select Type",
              balance: resp.data.balance || "0",
              notes: resp.data.notes,
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [acc_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="EDIT ACCOUNT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Account Title:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Account Title"
                  compulsory={true}
                  error={errors.name}
                />
                <TextInputField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Description"
                  compulsory={true}
                  error={errors.description}
                />
                <SelectField
                  label="Account Type:"
                  name="type"
                  value={formData.type}
                  placeholder="Account Type"
                  isDisabled
                  compulsory={true}
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  onChange={handleChange}
                  placeholder="Opening Balance"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.balance}
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditAccount;
